import * as IoC from 'typescript-ioc';
import { IntlShape } from 'react-intl';
import { withViewModel } from '../../../../../infrastructure/components/with-view-model';
import { IAgentMemoryDTO } from '../../../../../api/events.dao';
import { AgentMemoryFormPresentation } from './agent-memory-form.presentation';
import AgentMemoryFormVM from './agent-memory-form.viewmodel';

export interface IAgentMemoryFormContainerProps {
    intl: IntlShape;
    fetchAgentMemory: () => Promise<IAgentMemoryDTO | null>;
    saveAgentMemory: (agentMemory: string) => Promise<IAgentMemoryDTO | null>;
}

const AgentMemoryFormContainer = withViewModel(AgentMemoryFormPresentation, async (props: IAgentMemoryFormContainerProps) => {
    const agentMemoryFormVM = IoC.Container.get<AgentMemoryFormVM>(AgentMemoryFormVM);
    agentMemoryFormVM.initialize(props);
    await agentMemoryFormVM.load();
    return agentMemoryFormVM;
});

export { AgentMemoryFormContainer as AgentMemoryForm };
